import React from 'react';
import './SpecialSession.css';
import Navbar from './Navbar';
import Footer from './Footer';

const panelists = [
  {
    id: 1,
    name: 'Mr. Lokendra Raj Singh',
    designation: 'COO – JSW Steel Vijayanagar works',
    image: '/stis2025/assets/raj.jpg' // Placeholder - replace with actual image
  },
  {
    id: 2,
    name: 'Dr. Vishwanathan N',
    designation: 'Head - Research and Development, AM/NS India',
    image: '/stis2025/assets/vishwan.jpg' // Placeholder - replace with actual image
  },
  {
    id: 3,
    name: 'Dr. Siddharth Misra',
    designation: 'Chief Process Research, Tata Steel, India',
    image: '/stis2025/assets/sidmishra.jpg' // Placeholder - replace with actual image
  },
  {
    id: 4,
    name: 'Dr. K. Ramakrishna',
    designation: 'Executive Director, SAIL Ltd. India',
    image: '/stis2025/assets/rama.jpg' // Placeholder - replace with actual image
  },
  {
    id: 5,
    name: 'Dr. Brinda Varma',
    designation: 'Consultant, IPTEL, IISc Bengaluru, India',
    image: '/stis2025/assets/brinda.jpg' // Placeholder - replace with actual image
  }
];

const PanelistCard = ({ panelist }) => (
  <div className="panelist-card">
    <div className="panelist-image-wrapper">
      <img 
        src={panelist.image} 
        alt={panelist.name}
        className="panelist-image"
        onError={(e) => {
          e.target.src = '/stis2025/assets/speakers_upscaled/default-speaker.jpg';
        }}
      />
    </div>
    <div className="panelist-info">
      <h3 className="panelist-name">{panelist.name}</h3>
      <p className="panelist-designation">{panelist.designation}</p>
    </div>
  </div>
);

const SpecialSession = () => {
  return (
    <>
      <Navbar />
      <main className="special-session-container">
        <header className="special-session-header">
          <h1 className="special-session-title">Special Session</h1>
          <h2 className="special-session-subtitle">Innovation and Implementation in Industry</h2>
          <p className="special-session-date">Scheduled on 10th December 2025</p>
          <p>
            We are pleased to present a special session on "Innovation and Implementation in Industry" 
            featuring distinguished panelists from leading steel and metallurgical industries. 
            This session will explore cutting-edge innovations, implementation strategies, and 
            industry best practices.
          </p>
        </header>

       

        <section className="panelists-section">
          <h2 className="panelists-section-title">Distinguished Panelists</h2>
          <div className="panelists-grid">
            {panelists.map((panelist) => (
              <PanelistCard key={panelist.id} panelist={panelist} />
            ))}
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default SpecialSession;

